/** Prefer actionable field validation errors over a generic API message. */
export function apiErrorMessage(payload: unknown, fallback: string): string {
  const record = (value: unknown): Record<string, unknown> =>
    value !== null && typeof value === "object" && !Array.isArray(value)
      ? (value as Record<string, unknown>)
      : {};
  const body = record(payload);
  const error = record(body.error);
  const collect = (value: unknown, field = ""): string[] => {
    if (typeof value === "string" && value.trim()) {
      const label = field.replace(/_/g, " ");
      return [
        label
          ? `${label.charAt(0).toUpperCase()}${label.slice(1)}: ${value}`
          : value,
      ];
    }
    if (Array.isArray(value)) {
      return value.flatMap(item => collect(item, field));
    }
    return Object.entries(record(value)).flatMap(([key, item]) =>
      collect(
        item,
        ["non_field_errors", "detail", "message"].includes(key) ? field : key
      )
    );
  };
  for (const details of [error.details, body.details, body.errors]) {
    const messages = collect(details);
    if (messages.length) {
      return [...new Set(messages)].join("\n");
    }
  }
  for (const message of [
    error.message,
    body.detail,
    body.message,
    body.error,
  ]) {
    if (typeof message === "string" && message.trim()) {
      return message;
    }
  }
  return fallback;
}
